import Skeleton from 'react-loading-skeleton'
import SkeletonTheme from 'src/components/SkeletonTheme';

const OptionCardSkeleton = () => {
  return (
    <SkeletonTheme>
      <div className={`col-md-4 tw-mb-12 md:tw-mb-8`}>
        <div className="tw-h-64 tw-bg-grey-lightest tw-mb-3"></div>

        <div className="tw-flex tw-items-center tw-mb-2">
          <div className="tw-w-12">
            <Skeleton />
          </div>

          <span className="tw-mx-1.5"></span>

          <div className="tw-w-12">
            <Skeleton />
          </div>

          <span className="tw-mx-1.5"></span>

          <div className="tw-w-12">
            <Skeleton />
          </div>
        </div>

        <div className="tw-mb-2">
          <Skeleton count={2} />
        </div>
        <div className="tw-mb-2 tw-w-40">
          <Skeleton />
        </div>
        <div className="tw-mb-1">
          <Skeleton count={2} />
        </div>
        <div className="tw-w-24">
          <Skeleton count={1} />
        </div>
      </div>
    </SkeletonTheme>
  )
}

export default OptionCardSkeleton
